export default __webpack_public_path__ + "static/media/trello2.f5f5b0d8.png";